import {
  extractNumberedParagraphMeta,
  type NumberedParagraphMeta,
} from "./numberingCore";

export type { NumberedParagraphMeta };

export async function extractNumberingFromDocx(
  arrayBuffer: ArrayBuffer,
): Promise<NumberedParagraphMeta[]> {
  const JSZip = (await import("jszip")).default;
  const zip = await JSZip.loadAsync(arrayBuffer);
  const documentXml = await zip.file("word/document.xml")?.async("text");
  if (!documentXml) return [];

  const numberingXml =
    (await zip.file("word/numbering.xml")?.async("text")) ?? null;

  return extractNumberedParagraphMeta(documentXml, numberingXml);
}

export { extractNumberedParagraphMeta, parseNumberingDefinitions } from "./numberingCore";
